import { Dropdown, Option, Label } from '@fluentui/react-components';
import type { ToneType } from '../../types/index';

interface ToneSelectorProps {
  value: ToneType;
  onChange: (tone: ToneType) => void;
  disabled?: boolean;
}

const toneOptions: { value: ToneType; label: string; description: string }[] = [
  { value: 'formal', label: 'Formal', description: 'Professional and business-like' },
  { value: 'neutral', label: 'Neutral', description: 'Balanced and straightforward' },
  { value: 'casual', label: 'Casual', description: 'Friendly and conversational' },
];

export function ToneSelector({ value, onChange, disabled }: ToneSelectorProps) {
  const selectedOption = toneOptions.find((opt) => opt.value === value);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
      <Label size="small" style={{ color: 'var(--color-gray-600)' }}>
        Tone
      </Label>
      <Dropdown
        value={selectedOption?.label || 'Formal'}
        selectedOptions={[value]}
        onOptionSelect={(_, data) => {
          if (data.optionValue) {
            onChange(data.optionValue as ToneType);
          }
        }}
        disabled={disabled}
        style={{ minWidth: '140px' }}
      >
        {toneOptions.map((option) => (
          <Option key={option.value} value={option.value} text={option.label}>
            <div>
              <div style={{ fontWeight: 500 }}>{option.label}</div>
              <div style={{ fontSize: '12px', color: 'var(--color-gray-500)' }}>
                {option.description}
              </div>
            </div>
          </Option>
        ))}
      </Dropdown>
    </div>
  );
}
